module.exports = __webpack_public_path__ + "static/img/aboutUs_head.c4dd558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUs_head.png
// module id = WWIV
// module chunks = 1